// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"173":"8f0db8371f237bc4","260":"5834a41ae8db6b75","543":"0cd6ce6b09f9261a","547":"037adcc18cf8579a","667":"52f9b57f952cd426","713":"2b3acec35e44ed5f","775":"01c54f40944540ce","879":"597cb2065c5ccd81"}[chunkId] + ".js";
};